var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50219 2.17158C9.74987 1.91335 9.96067 1.66303 10.2031 1.44433C11.7709 0.0240914 13.589 -0.360612 15.5599 0.342921C17.4993 1.03591 18.6297 2.48514 18.9063 4.52723C19.1303 6.17671 18.6534 7.64438 17.4703 8.83802C15.2991 11.0303 13.1147 13.2068 10.9277 15.3832C10.1109 16.1948 8.8777 16.2001 8.0635 15.3885C5.85014 13.1857 3.6157 10.9987 1.44713 8.7537C0.00580854 7.26232 -0.339371 5.43366 0.324638 3.49169C0.978107 1.57608 2.37727 0.42197 4.38247 0.0952352C6.11891 -0.186705 7.64191 0.313937 8.90405 1.555C9.09641 1.74472 9.28085 1.9397 9.50482 2.16895L9.50219 2.17158ZM5.19931 1.17293C4.84095 1.2309 4.47206 1.25989 4.12424 1.35211C1.19417 2.13996 0.21397 5.83417 2.36673 8.02118C4.51685 10.2056 6.6986 12.361 8.86716 14.5269C9.23606 14.8958 9.74724 14.8958 10.1188 14.5243C12.2873 12.3583 14.4612 10.195 16.6218 8.01855C17.5836 7.04888 17.9367 5.85525 17.7127 4.52196C17.4598 3.02531 16.5955 1.96342 15.1647 1.45224C13.7181 0.935786 12.3532 1.16503 11.1648 2.16895C10.7353 2.53257 10.3559 2.9568 9.95277 3.35204C9.65238 3.64716 9.32565 3.64716 9.02526 3.34941C8.70116 3.02794 8.38233 2.70384 8.05823 2.38501C7.26775 1.60243 6.31653 1.21246 5.19667 1.17293H5.19931Z",
    fill: "#EC4E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutLine);
export default __webpack_public_path__ + "static/media/HeartOutLine.388907f8ce5180cbd6ea417ba60cfc43.svg";
export { ForwardRef as ReactComponent };